import React, { useEffect, useState } from "react";
import { subscribe } from "./api";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { getLocale } from "./i18nRefs.jsx";

// RFC2822-compliant regex https://www.regular-expressions.info/email.html
const isRFC2822Email = (email) => {
  return /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(email);
};
export const SubscribeEmailModal = ({ i18n, show, onClose }) => {
  let [email, setEmail] = useState("");
  let [name, setName] = useState("");
  let [submitting, setSubmitting] = useState(false);
  let [submitted, setSubmitted] = useState(false);
  let [error, setError] = useState("");


  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!isRFC2822Email(email)) {
        setError(i18n.PLS_ENTER_VALID_EMAIL);
        return false;
      } else {
        setError("");
      }

      setSubmitting(true);
      console.log(getLocale());
      const subscriber = { subscriber: email, name: name, lang: getLocale() };
      await subscribe(subscriber, "email");

      setSubmitting(false);
      setEmail("");
      setSubmitted(true);
    } catch (e) {
      console.error("really oh noes", e);
    }
    return false;
  };

  const validateEmail = (email) => {
    if (!isRFC2822Email(email)) {
      setError(i18n.PLS_ENTER_VALID_EMAIL);
    } else {
      setError("");
    }
  };

  useEffect(() => {
    setName("");
    setEmail("");
    setSubmitting(false);
    setSubmitted(false);
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      dialogClassName={"modal-dialog-centered"}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>{i18n.SUBSCRIBE_EMAIL}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          {!submitted && (
            <Form.Group>
              <Form.Label>{i18n.NAME}</Form.Label>
              <Form.Control
                type="name"
                placeholder={i18n.ENTER_NAME}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setError("");
                }}
                disabled={submitting}
              />
              <br />
              <Form.Label>{i18n.EMAIL}</Form.Label>
              <Form.Control
                type="email"
                placeholder={i18n.ENTER_EMAIL}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError("");
                }}
                onBlur={(e) => validateEmail(e.target.value)}
                disabled={submitting}
              />
              <br />
              <Form.Text>{i18n.PERSONAL_INFORMATION_DISCLOSURE}</Form.Text>
            </Form.Group>
          )}

          {error !== "" && (
            <Alert variant={"danger"}>
              <p>{error}</p>
            </Alert>
          )}

          {submitted && (
            <div className={"text-center"}>
              <p>{i18n.CONFIRM_EMAIL}</p>
              <p>{i18n.CONFIRMATIN_LINK_MESSAGE}</p>
            </div>
          )}

          <Row style={{ marginTop: "20px" }}>
            <Col>
              {!submitted && !submitting && (
                <Button variant="outline-danger" onClick={onClose}>
                  {i18n.CANCEL}
                </Button>
              )}
            </Col>
            <Col style={{ textAlign: "right" }}>
              {!submitted && (
                <Button variant="primary" type={"submit"}>
                  {!submitting ? (
                    i18n.SUBSCRIBE
                  ) : (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </Button>
              )}
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
